import * as Vuex from "vuex";
import { RootState, Errors } from "@/store/types";
type State = Errors;

const state: State = {
  errors: []
};

const getters: Vuex.GetterTree<State, RootState> = {};

const actions: Vuex.ActionTree<State, RootState> = {
  add({ commit }, args: { error: Error }) {
    commit("ADD_ERROR", args.error);
  }
};

const mutations: Vuex.MutationTree<State> = {
  ADD_ERROR(state, error: Error) {
    state.errors.push(error);
  }
};

export const app: Vuex.Module<State, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default app;
